document.addEventListener("DOMContentLoaded", function () {
    const target = document.querySelector(".christmas-collection-home .main-block .swiper-wrapper");

    if (target) {
        const button = document.createElement("a");
        button.href = "/collections/christmas-collection";
        button.className = "dt-sc-btn";
        button.textContent = "Shop Now";

        // Insert after the target element
        target.insertAdjacentElement("afterend", button);
    }
});

// Replace L and R text with arrow icons
document.addEventListener('DOMContentLoaded', function() {
  // Find all left arrow buttons
  const leftArrows = document.querySelectorAll('.arrow.left');
  const rightArrows = document.querySelectorAll('.arrow.right');
  
  // Left arrow SVG icon
  const leftArrowIcon = `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;
  
  // Right arrow SVG icon
  const rightArrowIcon = `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;
  
  // Replace left arrows
  leftArrows.forEach(function(arrow) {
    arrow.innerHTML = leftArrowIcon;
    arrow.style.display = 'flex';
    arrow.style.alignItems = 'center';
    arrow.style.justifyContent = 'center';
  });
  
  // Replace right arrows
  rightArrows.forEach(function(arrow) {
    arrow.innerHTML = rightArrowIcon;
    arrow.style.display = 'flex';
    arrow.style.alignItems = 'center';
    arrow.style.justifyContent = 'center';
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const checkbox = document.getElementById('add-plaque-checkbox');
  const plaqueMessageWrapper = document.querySelector('.plaque-message');
  const plaqueTextInput = document.getElementById('plaque_text');
  const addToCartButton = document.getElementById('dT_AddToCart-template--17198439727175__main');

  // UPDATED Plaque variant ID (your hidden product)
  const PLAQUE_VARIANT_ID = 42290694520903;

  console.log('Plaque JS loaded');

  // Show/hide plaque input
  checkbox.addEventListener('change', function () {
    plaqueMessageWrapper.style.display = checkbox.checked ? 'block' : 'none';
    if (!checkbox.checked) plaqueTextInput.value = '';
    console.log('Checkbox changed:', checkbox.checked);
  });

  // Limit plaque text to 4 words
  plaqueTextInput?.addEventListener('input', function () {
    const words = plaqueTextInput.value.trim().split(/\s+/);
    if (words.length > 4) {
      plaqueTextInput.value = words.slice(0, 4).join(' ');
      console.log('Limited plaque message to 4 words:', plaqueTextInput.value);
    }
  });

  // Override Add to Cart button
  addToCartButton.addEventListener('click', function (event) {
    event.preventDefault(); // Stop default theme add
    event.stopPropagation();
    console.log('Add to Cart button clicked');

    const form = addToCartButton.closest('form');
    if (!form) {
      console.error('Product form not found!');
      return;
    }

    const productIdInput = form.querySelector('[name="id"]');
    const quantityInput = form.querySelector('[name="quantity"]');

    if (!productIdInput) {
      console.error('Product ID input not found!');
      return;
    }

    const mainVariantId = productIdInput.value;
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

    console.log('Main product ID:', mainVariantId, 'Quantity:', quantity);

    // Add main product via AJAX
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: mainVariantId, quantity: quantity })
    })
      .then(res => res.json())
      .then(mainProduct => {
        console.log('Main product added successfully:', mainProduct);

        // If checkbox is checked, add plaque variant
        if (checkbox.checked) {
          console.log('Adding plaque variant:', PLAQUE_VARIANT_ID);

          // Line item property to store user-written message
          const properties = {};
          if (plaqueTextInput.value.trim() !== '') {
            properties['Plaque message'] = plaqueTextInput.value.trim();
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              id: PLAQUE_VARIANT_ID,
              quantity: 1,
              properties: properties
            })
          })
            .then(res => res.json())
            .then(plaqueProduct => {
              console.log('Plaque variant added successfully:', plaqueProduct);
              // Redirect to cart so totals and line items are updated
              window.location.href = '/cart';
            })
            .catch(err => {
              console.error('Plaque add failed. Check if the variant is available and online:', err);
            });
        } else {
          // If no plaque, just go to cart
          window.location.href = '/cart';
        }
      })
      .catch(err => console.error('Main product add failed:', err));
  });
});


